import { ExperimentAttribution } from "@recare/core/types";

export function getExperiment({
  experimentName,
  experiments,
}: {
  experimentName: string;
  experiments: Array<ExperimentAttribution> | undefined;
}) {
  if (!experiments?.length) return false;

  for (const experiment of experiments) {
    if (
      experiment.experiment_name === experimentName &&
      experiment.experiment_value === "true"
    )
      return true;
  }
  return false;
}
